import Vue from 'vue'
import Vuex from 'vuex'
// import api from '../api.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    cursor: null,
    showMyCursor: true
  },
  mutations: {
    MOVE_CURSOR (state, payload) {
      state.cursor = payload
    },
    SET_SHOW_MY_CURSOR (state, payload) {
      state.showMyCursor = payload
    }
  },
  actions: {
  },
  modules: {},
  getters: {
  }
})
